import React, { CSSProperties, useEffect, useState } from 'react';

import AssetService from '../../services/AssetService';
import Avatar from '@mui/material/Avatar';
import DisplaySettings from '../../../dashboard/models/DisplaySettings';
import Grid from '@mui/material/Unstable_Grid2';
import HighlightedText from './HighlightedText';
import { Typography } from '@mui/material';
import { styled } from '@mui/system';
import styles from '../../styles/CourseDialog.module.scss';

const StyledDiv = styled('div')(({ theme }) => ({
  flex: 1
}));

const StyledAvatar = styled(Avatar)(({ theme }) => ({
  width: theme.spacing(5),
  height: theme.spacing(5),
  fontSize: '20px',
  '@media (max-width: 500px)': {
    width: theme.spacing(5),
    height: theme.spacing(5),
    fontSize: '16px'
  },
  backgroundColor: theme.palette.grey[500]
}));

export interface ITitleDescStyledDiv {
  title: string;
  description?: string;
  tags?: string;
  searchText: string;
  displaySettings?: DisplaySettings;
}

/** Used in both course and collection list page */
const SearchList = (props: ITitleDescStyledDiv) => {
  const { title, description, displaySettings, searchText, tags } = props;
  const [avatarStyle, setAvatarStyle] = useState<CSSProperties>();
  const [avatarImage, setAvatarImage] = useState('');

  useEffect(() => {
    if ((displaySettings as DisplaySettings)?.colour) {
      setAvatarStyle({
        backgroundColor: (displaySettings as DisplaySettings).colour || '#9e'
      });
    }
    if ((displaySettings as DisplaySettings)?.image) {
      setAvatarImage(
        AssetService.getAssetUrl((displaySettings as DisplaySettings).image)
      );
    }
  }, []);

  return (
    <StyledDiv>
      <Grid container alignItems="center" wrap="nowrap">
        <Grid
          className={`${styles.itemSpacing} ${styles.courseImage}`}
          minWidth={'unset'}
        >
          <StyledAvatar style={avatarStyle} src={avatarImage}>
            {title?.toUpperCase()[0]}
          </StyledAvatar>
        </Grid>
        <Grid className={styles.itemSpacing} minWidth={'unset'}>
          <Grid container direction="column">
            <HighlightedText
              variant={'subtitle2'}
              text={title}
              searchQuery={searchText}
            />
            {description && (
              <HighlightedText
                variant={'caption'}
                text={description}
                searchQuery={searchText}
              />
            )}
            {tags && (
              <Grid container alignItems="center">
                <Typography variant="subtitle2" style={{ paddingRight: '5px' }}>
                  Keywords:
                </Typography>
                <HighlightedText
                  variant={'caption'}
                  text={tags}
                  searchQuery={searchText}
                />
              </Grid>
            )}
          </Grid>
        </Grid>
      </Grid>
    </StyledDiv>
  );
};
export default SearchList;
